module.exports = __webpack_public_path__ + "static/media/InformationRequest.8c0ab5dc.jpg";